(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ProductAPIService', productAPIService);

    function productAPIService(HttpService) {
        function renameProduct(productId, newName) {
            var data = {
                productId: productId,
                name: newName
            };
            var url = '/Product/Rename?' + $.param(data);
            return HttpService.post(url);
        }

        function generateProductGUID() {
            return HttpService.get('/Product/ProductGUID');
        }

        function getProduct(id) {
            const data = {
                productId: id,
                useListEPS: true
            };
            return HttpService.get('/Product?' + $.param(data));
        }

        function saveProduct(product) {
            var url = '/Product/SaveProduct';
            var data = {
                jsonString: JSON.stringify(product)
            };
            return HttpService.post(url, data);
        }

        function getProductsFromTo(
            searchString,
            sortBy,
            sortMode,
            from,
            to,
            linked = undefined,
            deleted = undefined,
            fullAccessOnly = undefined
        ) {
            var data = {
                searchString: searchString,
                sortBy: sortBy,
                sortMode: sortMode,
                from: from,
                to: to,
                linked,
                deleted,
                fullAccessOnly
            };
            return HttpService.get('/Product/GetProductsFromTo?' + $.param(data));
        }

        function getProductsCount(searchString, linked = undefined, deleted = undefined, fullAccessOnly = undefined) {
            var data = {
                searchString: searchString,
                linked,
                deleted,
                fullAccessOnly
            };
            return HttpService.get('/Product/GetProductsCount?' + $.param(data));
        }

        function deleteProduct(productId) {
            var data = {
                productId: productId
            };
            return HttpService.get('/Product/DeleteProduct?' + $.param(data));
        }

        function deleteProductRange(productIds) {
            return HttpService.post('/Product/DeleteProductRange', JSON.stringify({ productIds }));
        }

        function restoreProduct(id) {
            var data = {
                id: id
            };
            return HttpService.post('/Product/RestoreProduct?' + $.param(data));
        }

        function cloneProduct(id) {
            var data = {
                productId: id
            };
            return HttpService.get('/Product/CloneProduct?' + $.param(data));
        }

        function getProductsWithFont(fontName) {
            var data = {
                fontName: fontName
            };
            return HttpService.get('/Product/GetProductsWithFont?' + $.param(data));
        }

        function getExportUrl(productId) {
            return HttpService.get(`/Product/${encodeURIComponent(productId)}/ExportUrl`);
        }

        function getProductImportSignedUrl() {
            return HttpService.get(`/Product/ImportSignedUrl`);
        }

        function importProductZip(filename) {
            return HttpService.get(`/Product/Import/${encodeURIComponent(filename)}`);
        }

        function getProductTemplateRelations(productId) {
            var data = {
                productId: productId
            };
            return HttpService.get('/Product/ProductTemplateRelations?' + $.param(data));
        }

        return {
            getProduct: getProduct,
            generateProductGUID: generateProductGUID,
            saveProduct: saveProduct,
            getProductsFromTo: getProductsFromTo,
            getProductsCount: getProductsCount,
            deleteProduct: deleteProduct,
            cloneProduct: cloneProduct,
            getProductsWithFont: getProductsWithFont,
            renameProduct: renameProduct,
            getExportUrl: getExportUrl,
            getProductImportSignedUrl: getProductImportSignedUrl,
            importProductZip: importProductZip,
            restoreProduct,
            getProductTemplateRelations: getProductTemplateRelations,
            deleteProductRange
        };
    }
})();
